import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import appEN from './locales/en/en.json';
import appENX from './locales/enX/enX.json';
import appES from './locales/es/es.json';
import appDE from './locales/de/de.json';

const resources = {
  en_US: {
    app: appEN,
  },
  enX: {
    app: appENX,
  },
  es_ES: {
    app: appES,
  },
  de_DE: {
    app: appDE,
  },
};

const backendOpts = {
  loadPath: `${window.location.pathname}/locales/{{lng}}/{{ns}}.json`,
};

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next) // if not using I18nextProvider
  .init({
    lng: 'en_US',
    fallbackLng: 'en_US',
    debug: false,
    keySeparator: false,

    resources,
    // ns: ['shortcuts', 'login'],
    // defaultNS: 'login',

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    backend: backendOpts,

    // react i18next special options (optional)
    // react: {
    //   wait: false,
    //   bindI18n: "languageChanged loaded",
    //   bindStore: "added removed",
    //   nsMode: "default",
    // },
  });

export default i18n;
